import { checkPermissions } from "@elit-hair/elit-tools";
import { Button, Icon, Popover, PopoverContent, PopoverTrigger, Tooltip, TooltipContent, TooltipTrigger } from "@elit-hair/elit-ui";
import { useTranslation } from "react-i18next";
import { TbDialpad } from "react-icons/tb";

import { HeaderCallDialerContent } from "@/components/header/call-dialer-content";
import { HEADER_ACTION_BUTTON_CLASS, HEADER_DIALER_POPOVER_CLASS } from "@/components/header/constants/header-controls";
import { HeaderCallDialerVariant } from "@/components/header/types/call-dialer.types";
import { PERMISSIONS } from "@/constants/permissions";
import { useDashboardRole } from "@/pages/home/components/role-dashboard/hooks/useDashboardRole";

export function HeaderDialerPopover() {
    const { t } = useTranslation();
    const { permissionCodes } = useDashboardRole();
    const canUseDialer = checkPermissions(permissionCodes, [PERMISSIONS.CALL_DIALER]);

    if (!canUseDialer) {
        return null;
    }

    return (
        <Popover>
            <Tooltip>
                <TooltipTrigger asChild>
                    <PopoverTrigger asChild>
                        <Button className={HEADER_ACTION_BUTTON_CLASS} aria-label={t("dialer")}>
                            <Icon icon={TbDialpad} />
                        </Button>
                    </PopoverTrigger>
                </TooltipTrigger>
                <TooltipContent side="bottom" sideOffset={5}>
                    {t("dialer")}
                </TooltipContent>
            </Tooltip>
            <PopoverContent align="end" sideOffset={8} className={HEADER_DIALER_POPOVER_CLASS}>
                <p className="mb-2 text-sm font-medium">{t("dialer")}</p>
                <HeaderCallDialerContent variant={HeaderCallDialerVariant.DIALER} />
            </PopoverContent>
        </Popover>
    );
}
